/* src/app/components/manageclient/manageclient.component.scss */
:host {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: stretch;
}
.user-section {
  padding: 1.5rem;
  background:
    linear-gradient(
      135deg,
      #f9fafb 0%,
      #f5f7fa 100%);
  min-height: 100vh;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section {
    padding: 0.875rem;
  }
}
@media (max-width: 768px) {
  .user-section {
    padding: 0.75rem;
  }
}
.user-section .top-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .top-actions {
    gap: 0.75rem;
    margin-bottom: 0.875rem;
  }
}
@media (max-width: 768px) {
  .user-section .top-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
  }
}
.user-section .top-actions .search-box {
  position: relative;
  flex: 1 1 250px;
  max-width: 400px;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .top-actions .search-box {
    flex: 1 1 300px;
    max-width: 350px;
  }
}
@media (max-width: 768px) {
  .user-section .top-actions .search-box {
    max-width: 100%;
    flex: 1 1 100%;
  }
}
.user-section .top-actions .search-box input {
  width: 100%;
  padding: 0.7rem 1rem 0.7rem 2.8rem;
  border-radius: 12px;
  border: 1.5px solid #e0e4e8;
  font-size: 0.95rem;
  background: #fff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
@media (max-width: 768px) {
  .user-section .top-actions .search-box input {
    padding: 0.75rem 1rem 0.75rem 2.8rem;
    font-size: 1rem;
  }
}
.user-section .top-actions .search-box input:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12), 0 2px 6px rgba(0, 0, 0, 0.08);
  outline: none;
  transform: translateY(-1px);
}
.user-section .top-actions .search-box input::placeholder {
  color: #9ca3af;
}
.user-section .top-actions .search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #4b5563;
  transition: color 0.3s ease;
  z-index: 1;
  pointer-events: none;
}
.user-section .top-actions .search-box:focus-within .search-icon {
  color: #1571b9;
}
.user-section .top-actions .action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .top-actions .action-buttons {
    gap: 0.4rem;
  }
}
@media (max-width: 768px) {
  .user-section .top-actions .action-buttons {
    width: 100%;
    justify-content: stretch;
  }
}
.user-section .top-actions .action-buttons .btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.2rem;
  border: 1.5px solid #e0e4e8;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  color: #1571b9;
  background: #fff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .top-actions .action-buttons .btn {
    padding: 0.55rem 0.85rem;
    font-size: 0.88rem;
  }
}
@media (max-width: 768px) {
  .user-section .top-actions .action-buttons .btn {
    flex: 1;
    justify-content: center;
    padding: 0.75rem 1rem;
    font-size: 0.95rem;
  }
}
.user-section .top-actions .action-buttons .btn.primary:hover {
  background: #1571b9;
  color: #fff;
  border-color: #1571b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);
}
.user-section .top-actions .action-buttons .btn.primary:active {
  transform: translateY(0);
}
.user-section .top-actions .action-buttons .btn.info:hover {
  background: #1571b9;
  color: #fff;
  border-color: #1571b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);
}
.user-section .top-actions .action-buttons .btn.info:active {
  transform: translateY(0);
}
.user-section .top-actions .action-buttons .btn.success:hover {
  background: #1571b9;
  color: #fff;
  border-color: #1571b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.25);
}
.user-section .top-actions .action-buttons .btn.success:active {
  transform: translateY(0);
}
.user-section .top-actions .action-buttons .btn i {
  font-size: 1rem;
  transition: transform 0.3s ease;
}
.user-section .top-actions .action-buttons .btn:hover i {
  transform: scale(1.1);
}
@media (max-width: 480px) {
  .user-section .top-actions .action-buttons .btn span {
    display: none;
  }
}
.user-section .desktop-view {
  display: block;
}
@media (max-width: 768px) {
  .user-section .desktop-view {
    display: none;
  }
}
.user-section .table-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  overflow-x: auto;
  height: 66vh;
  margin-bottom: 1rem;
  border: 1px solid #e5e7eb;
  transition: box-shadow 0.3s ease;
}
.user-section .table-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}
.user-section .table-card .user-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .table-card .user-table {
    min-width: 100%;
  }
  .user-section .table-card .user-table th,
  .user-section .table-card .user-table td {
    padding: 0.6rem 0.5rem;
    font-size: 0.85rem;
    white-space: normal;
    word-wrap: break-word;
  }
  .user-section .table-card .user-table th:nth-child(1),
  .user-section .table-card .user-table td:nth-child(1) {
    min-width: 120px;
    max-width: 150px;
  }
  .user-section .table-card .user-table th:nth-child(2),
  .user-section .table-card .user-table td:nth-child(2) {
    min-width: 180px;
    max-width: 220px;
  }
  .user-section .table-card .user-table th:nth-child(2) div,
  .user-section .table-card .user-table td:nth-child(2) div {
    line-height: 1.4;
  }
  .user-section .table-card .user-table th:nth-child(2) div:first-child,
  .user-section .table-card .user-table td:nth-child(2) div:first-child {
    margin-bottom: 0.25rem;
  }
  .user-section .table-card .user-table th:nth-child(3),
  .user-section .table-card .user-table td:nth-child(3) {
    min-width: 120px;
    max-width: 150px;
  }
  .user-section .table-card .user-table th:nth-child(4),
  .user-section .table-card .user-table td:nth-child(4) {
    min-width: 80px;
    max-width: 100px;
  }
  .user-section .table-card .user-table th:nth-child(5),
  .user-section .table-card .user-table td:nth-child(5) {
    min-width: 110px;
    max-width: 130px;
  }
  .user-section .table-card .user-table th:nth-child(6),
  .user-section .table-card .user-table td:nth-child(6) {
    min-width: 120px;
    max-width: 140px;
  }
  .user-section .table-card .user-table .actions {
    flex-wrap: wrap;
    gap: 0.3rem;
  }
  .user-section .table-card .user-table .actions .icon-btn {
    padding: 0.25rem;
    min-width: 32px;
    min-height: 32px;
  }
  .user-section .table-card .user-table .actions .icon-btn i {
    font-size: 0.9rem;
  }
}
.user-section .table-card .user-table th,
.user-section .table-card .user-table td {
  padding: 0.75rem 0.65rem;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
  white-space: nowrap;
  font-size: 0.9rem;
}
.user-section .table-card .user-table thead {
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      #f1f5f9 100%);
  position: sticky;
  top: 0;
  z-index: 10;
}
.user-section .table-card .user-table thead th {
  font-weight: 600;
  font-size: 0.9rem;
  color: #1f2937;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  padding: 0.75rem 0.65rem;
}
.user-section .table-card .user-table tbody tr {
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}
.user-section .table-card .user-table tbody tr:hover {
  background: #f8fafc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.user-section .table-card .user-table tbody .no-record {
  text-align: center;
  color: #9ca3af;
  font-style: italic;
  padding: 2rem;
  font-size: 1rem;
}
.user-section .table-card .user-table .status {
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.user-section .table-card .user-table .status.active {
  background:
    linear-gradient(
      135deg,
      #d1fae5 0%,
      #a7f3d0 100%);
  color: #065f46;
  border: 1px solid #6ee7b7;
}
.user-section .table-card .user-table .status.inactive {
  background:
    linear-gradient(
      135deg,
      #fee2e2 0%,
      #fecaca 100%);
  color: #991b1b;
  border: 1px solid #fca5a5;
}
.user-section .table-card .user-table .actions {
  display: flex;
  gap: 0.5rem;
}
.user-section .table-card .user-table .actions .icon-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
}
.user-section .table-card .user-table .actions .icon-btn i {
  font-size: 1.1rem;
  transition: transform 0.3s ease;
}
.user-section .table-card .user-table .actions .icon-btn.success {
  color: #10b981;
}
.user-section .table-card .user-table .actions .icon-btn.success:hover {
  background: rgba(16, 185, 129, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(16, 185, 129, 0.2);
}
.user-section .table-card .user-table .actions .icon-btn.success:hover i {
  transform: rotate(180deg) scale(1.1);
}
.user-section .table-card .user-table .actions .icon-btn.warning {
  color: #1571b9;
}
.user-section .table-card .user-table .actions .icon-btn.warning:hover {
  background: rgba(21, 114, 185, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(21, 114, 185, 0.2);
}
.user-section .table-card .user-table .actions .icon-btn.warning:hover i {
  transform: scale(1.15);
}
.user-section .table-card .user-table .actions .icon-btn.danger {
  color: #ef4444;
}
.user-section .table-card .user-table .actions .icon-btn.danger:hover {
  background: rgba(239, 68, 68, 0.15);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.2);
}
.user-section .table-card .user-table .actions .icon-btn.danger:hover i {
  transform: scale(1.15);
}
.user-section .mobile-view {
  display: none;
}
@media (max-width: 768px) {
  .user-section .mobile-view {
    display: block;
  }
}
.user-section .mobile-view .no-record-card {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  color: #888;
  font-style: italic;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.user-section .mobile-view .client-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 1rem;
  padding: 1rem;
  transition: all 0.3s ease;
}
.user-section .mobile-view .client-card:active {
  transform: scale(0.98);
}
.user-section .mobile-view .client-card .client-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #eaeaea;
}
.user-section .mobile-view .client-card .client-card-header .client-name {
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
  flex: 1;
}
.user-section .mobile-view .client-card .client-card-header .status {
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
  display: inline-block;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.user-section .mobile-view .client-card .client-card-header .status.active {
  background:
    linear-gradient(
      135deg,
      #d1fae5 0%,
      #a7f3d0 100%);
  color: #065f46;
  border: 1px solid #6ee7b7;
}
.user-section .mobile-view .client-card .client-card-header .status.inactive {
  background:
    linear-gradient(
      135deg,
      #fee2e2 0%,
      #fecaca 100%);
  color: #991b1b;
  border: 1px solid #fca5a5;
}
.user-section .mobile-view .client-card .client-card-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
}
.user-section .mobile-view .client-card .client-card-body .client-info-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}
.user-section .mobile-view .client-card .client-card-body .client-info-row i {
  color: #1571b9;
  font-size: 1.1rem;
  margin-top: 0.2rem;
  min-width: 20px;
}
.user-section .mobile-view .client-card .client-card-body .client-info-row .info-label {
  font-size: 0.75rem;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.user-section .mobile-view .client-card .client-card-body .client-info-row .info-value {
  font-size: 0.95rem;
  color: #333;
  word-break: break-word;
}
.user-section .mobile-view .client-card .client-card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 0.75rem;
  border-top: 1px solid #eaeaea;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn i {
  font-size: 1.1rem;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.success {
  color: #28a745;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.success:active {
  background: rgba(40, 167, 69, 0.2);
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.warning {
  color: #1571b9;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.warning:active {
  background: rgba(21, 114, 185, 0.2);
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.danger {
  color: #dc3545;
}
.user-section .mobile-view .client-card .client-card-actions .icon-btn.danger:active {
  background: rgba(220, 53, 69, 0.2);
}
.user-section .pagination-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  font-family: "Inter", sans-serif;
  transition: all 0.3s ease-in-out;
}
.user-section .pagination-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .pagination-container {
    padding: 0.65rem 1rem;
  }
}
.user-section .pagination-container .pagination-info {
  color: #374151;
  font-size: 0.95rem;
  font-weight: 500;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .pagination-container .pagination-info {
    font-size: 0.9rem;
  }
}
.user-section .pagination-container .pagination-info span {
  background: #f3f4f6;
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .user-section .pagination-container .pagination-info span {
    padding: 0.3rem 0.65rem;
  }
}
.user-section .pagination-container .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination {
  margin: 0;
  list-style: none;
  padding: 0;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li {
  align-items: center;
  vertical-align: middle;
  margin: 0 0.25rem;
  height: 30px;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li.active a {
  background:
    linear-gradient(
      90deg,
      #2563eb,
      #1d4ed8);
  color: #fff !important;
  border-color: transparent;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  font-size: 0.9rem;
  color: #374151;
  background: #f9fafb;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 500;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li a:hover {
  background: #e5e7eb;
  border-color: #1571b9;
  color: #1571b9;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination li.disabled a {
  opacity: 0.5;
  cursor: not-allowed;
}
.user-section .pagination-container .pagination-controls ::ng-deep .ngx-pagination .current span {
  height: 25px;
  display: flex;
  align-items: center;
}
@media (max-width: 600px) {
  .user-section .pagination-container {
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
  }
  .user-section .pagination-container .pagination-info {
    order: 2;
  }
  .user-section .pagination-container .pagination-controls {
    order: 1;
  }
}
textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1.5px solid #e0e4e8;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fff;
  font-size: 0.95rem;
  font-family: inherit;
  resize: vertical;
}
@media (min-width: 750px) and (max-width: 1300px) {
  textarea {
    padding: 0.55rem 0.6rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  textarea {
    padding: 0.75rem;
    font-size: 1rem;
  }
}
textarea:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12);
  outline: none;
  transform: translateY(-1px);
}
textarea::placeholder {
  color: #9ca3af;
}
.custom-modal {
  position: fixed;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.custom-modal.is-active {
  display: flex;
}
.custom-modal .custom-modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
}
.custom-modal .custom-modal-container {
  position: relative;
  z-index: 2;
  background: #fff;
  border-radius: 1.25rem;
  width: 90%;
  max-width: 800px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 2rem;
  animation: modalSlideIn 0.3s ease-out;
}
@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .custom-modal-container {
    width: 85%;
    max-width: 750px;
    padding: 1rem 1.25rem;
    max-height: 95vh;
  }
}
@media (max-width: 768px) {
  .custom-modal .custom-modal-container {
    width: 95%;
    max-height: 95vh;
    border-radius: 0.75rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .custom-modal-container {
    width: 100%;
    max-height: 100vh;
    border-radius: 0;
    padding: 0.75rem;
  }
}
.custom-modal .custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  order: 0;
}
.custom-modal .custom-modal-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}
.custom-modal .custom-modal-header .close-btn {
  background: #f3f4f6;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #6b7280;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.custom-modal .custom-modal-header .close-btn:hover {
  background: #e5e7eb;
  color: #1f2937;
  transform: rotate(90deg);
}
.custom-modal .custom-modal-body {
  margin-top: 1rem;
  flex: 1;
  overflow-y: auto;
}
.custom-modal .form-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.custom-modal .form-grid .input-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-start;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .form-grid .input-row {
    gap: 0.875rem;
  }
}
@media (max-width: 768px) {
  .custom-modal .form-grid .input-row {
    flex-direction: column;
    gap: 0.75rem;
  }
}
.custom-modal .form-grid .input-row .input-group {
  flex: 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .form-grid .input-row .input-group {
    min-width: 180px;
    flex: 1 1 calc(33.333% - 0.583rem);
  }
  .custom-modal .form-grid .input-row .input-group:only-child,
  .custom-modal .form-grid .input-row .input-group:nth-child(2):last-child {
    flex: 1 1 calc(50% - 0.4375rem);
  }
}
@media (max-width: 768px) {
  .custom-modal .form-grid .input-row .input-group {
    min-width: 100%;
    flex: 1 1 100%;
  }
}
.custom-modal .form-grid .input-row .input-group label {
  font-weight: 500;
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.9rem;
}
@media (max-width: 480px) {
  .custom-modal .form-grid .input-row .input-group label {
    font-size: 0.85rem;
  }
}
.custom-modal .form-grid .input-row .input-group label span {
  color: #ff4757;
}
.custom-modal .form-grid .input-row .input-group input,
.custom-modal .form-grid .input-row .input-group select {
  width: 100%;
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  transition: all 0.3s;
  font-size: 0.95rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .form-grid .input-row .input-group input,
  .custom-modal .form-grid .input-row .input-group select {
    padding: 0.55rem 0.6rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .form-grid .input-row .input-group input,
  .custom-modal .form-grid .input-row .input-group select {
    padding: 0.75rem;
    font-size: 1rem;
  }
}
.custom-modal .form-grid .input-row .input-group input:focus,
.custom-modal .form-grid .input-row .input-group select:focus {
  border-color: #1571b9;
  box-shadow: 0 0 0 4px rgba(21, 113, 185, 0.12);
  outline: none;
  transform: translateY(-1px);
}
.custom-modal .form-grid .input-row .input-group input::placeholder,
.custom-modal .form-grid .input-row .input-group select::placeholder {
  color: #9ca3af;
}
.custom-modal .form-grid .input-row .input-group form-validation {
  display: block;
  margin-top: 0.25rem;
  min-height: 1.2rem;
}
.custom-modal .form-grid .input-row.full-width {
  width: 100%;
}
.custom-modal .form-grid .profile-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
}
.custom-modal .form-grid .profile-section .profile-wrapper {
  position: relative;
  text-align: center;
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e5e7eb;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-image:hover {
  border-color: #1571b9;
  box-shadow: 0 6px 16px rgba(21, 113, 185, 0.2);
  transform: scale(1.05);
}
@media (max-width: 480px) {
  .custom-modal .form-grid .profile-section .profile-wrapper .profile-image {
    width: 80px;
    height: 80px;
  }
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action .file-label {
  cursor: pointer;
  color: #1571b9;
  font-size: 1rem;
  padding: 0.5rem;
}
@media (max-width: 480px) {
  .custom-modal .form-grid .profile-section .profile-wrapper .profile-action .file-label {
    font-size: 0.9rem;
  }
}
.custom-modal .form-grid .profile-section .profile-wrapper .profile-action .remove-btn {
  background: none;
  border: none;
  color: #ff4757;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0.5rem;
}
@media (max-width: 480px) {
  .custom-modal .form-grid .profile-section .profile-wrapper .profile-action .remove-btn {
    font-size: 0.85rem;
  }
}
.custom-modal .custom-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  border-top: 1px solid #eee;
  padding-top: 0.8rem;
  margin-top: 1rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .custom-modal-footer {
    gap: 0.875rem;
    padding-top: 0.75rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .custom-modal-footer {
    flex-direction: column-reverse;
    gap: 0.75rem;
  }
}
.custom-modal .custom-modal-footer .primary-btn {
  background:
    linear-gradient(
      135deg,
      #1571b9 0%,
      #0d5a9a 100%);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.75rem 1.8rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(21, 113, 185, 0.3);
  font-size: 0.95rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .custom-modal-footer .primary-btn {
    padding: 0.55rem 1.2rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .custom-modal-footer .primary-btn {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
  }
}
.custom-modal .custom-modal-footer .primary-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.custom-modal .custom-modal-footer .primary-btn:hover:not(:disabled) {
  background-color: #1571b9;
}
.custom-modal .custom-modal-footer .primary-btn:active:not(:disabled) {
  transform: scale(0.98);
}
.custom-modal .custom-modal-footer .cancel-btn {
  background-color: #f9fafb;
  color: #374151;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 0.75rem 1.8rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.95rem;
}
@media (min-width: 750px) and (max-width: 1300px) {
  .custom-modal .custom-modal-footer .cancel-btn {
    padding: 0.55rem 1.2rem;
    font-size: 0.9rem;
  }
}
@media (max-width: 480px) {
  .custom-modal .custom-modal-footer .cancel-btn {
    width: 100%;
    padding: 0.75rem 1rem;
    font-size: 1rem;
  }
}
.custom-modal .custom-modal-footer .cancel-btn:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.custom-modal .custom-modal-footer .cancel-btn:active {
  transform: translateY(0);
}
.custom-modal .file-upload-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.custom-modal .file-upload-section input[type=file] {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  background: #fff;
  cursor: pointer;
}
.custom-modal .file-upload-section .attachment-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.custom-modal .file-upload-section .attachment-list .attachment-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  background: #f5f5f5;
  border-radius: 0.4rem;
  font-size: 0.9rem;
}
@media (max-width: 480px) {
  .custom-modal .file-upload-section .attachment-list .attachment-item {
    padding: 0.75rem;
    font-size: 0.85rem;
  }
}
.custom-modal .file-upload-section .attachment-list .attachment-item span {
  flex: 1;
  word-break: break-word;
  margin-right: 0.5rem;
}
.custom-modal .file-upload-section .attachment-list .attachment-item .remove-attachment {
  background: none;
  border: none;
  color: #dc3545;
  cursor: pointer;
  padding: 0.2rem 0.5rem;
  border-radius: 0.3rem;
  transition: all 0.2s;
  flex-shrink: 0;
}
.custom-modal .file-upload-section .attachment-list .attachment-item .remove-attachment:hover {
  background: rgba(220, 53, 69, 0.1);
}
.custom-modal .file-upload-section .attachment-list .attachment-item .remove-attachment:active {
  background: rgba(220, 53, 69, 0.2);
}
.custom-modal .file-upload-section .attachment-list .attachment-item .remove-attachment i {
  font-size: 0.9rem;
}
/*# sourceMappingURL=manageclient.component.css.map */
